import { createFeatureSelector, createSelector } from "@ngrx/store";
import { BackCounterState } from "./back-counter.state";

export const selectBackCounterFeature = createFeatureSelector<BackCounterState>('backCounter');

export const selectBackCounterRequestsLoading = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.loading
);

export const selectBackCounterRequests = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.requests
);

export const selectBackCounterTotalRequestCount = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.totalRequestCount
);

export const selectBackCounterOpenRequests = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.openRequests
);

export const selectRequestPriceVerifications = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.priceVerifyItems
);

export const selectRequestDetails = (requestId: string) =>
  createSelector(selectBackCounterFeature,
  (state: BackCounterState) => state.openRequests.find(x => x.orderNumber === requestId )
);

export const selectHasNote = (requestId: string) =>
  createSelector(selectBackCounterFeature,
  (state: BackCounterState) => state.openRequests.find(x => x.orderNumber === requestId )?.ordertogetjob?.some(s => s.noteExists === 'X')
);

export const selectRequestDetailsUnsavedChanges = (requestId: string) =>
  createSelector(selectBackCounterFeature,
  (state: BackCounterState) => state.unsavedChanges[requestId]
);

export const selectRequestDetailsLoading = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.requestDetailsLoading
);

export const selectBackCounterIsConfirmationLoading = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.isConfirmationLoading
);

export const selectRequestAttachments = (requestId: string) =>
  createSelector(selectBackCounterFeature,
  (state: BackCounterState) => state.openRequestsAttachments.find(x => x.orderNumber === requestId)?.attachments ?? []
);

export const selectUnsavedAttachment = (requestId: string) =>
  createSelector(selectBackCounterFeature,
  (state: BackCounterState) => state.unsavedChanges[requestId]?.hasUnsavedAttachment
);

export const selectBackCounterRequestNotes = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.requestNotes
);

export const selectJobNotifflag = (requestId: string) =>
  createSelector(selectBackCounterFeature,
  (state: BackCounterState) => state.openRequests.find(x => x.orderNumber === requestId )?.ordertogetjob?.some(s => s.jobNotifflag?.toLocaleLowerCase() === 'x') && !state.openedHeaderNotes[requestId]
);

export const selectOpenRequestsAttachments = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.openRequestsAttachments
);

export const selectInventories = createSelector(
  selectBackCounterFeature,
  (state: BackCounterState) => state.inventories
);

export const selectHasRequestEngineSerialNumberChanged = (requestId: string) =>
  createSelector(selectBackCounterFeature,
  (state: BackCounterState) => state.openRequests.find(f => f.orderNumber === requestId)?.hasEngineSerialNumberUpdated
);
